export const normalizeValue = value => {
  if (value === null) {
    return '';
  }
  return value;
};